import { memo, useCallback } from 'react'
import { RosterFormData } from 'types/roster'
import { Button, Form, InputNumber, Space, Switch } from 'antd'

type Props = {
    roster?: RosterFormData
    onSubmit: (data: RosterFormData) => void
}

export const RosterForm = memo((props: Props) => {
    const { roster, onSubmit } = props

    const onFinish = useCallback(
        (values: RosterFormData & { mvpChecked?: boolean }) => {
            const { mvpChecked, ...rest } = values
            onSubmit({
                ...rest,
                mvp: mvpChecked ? 1 : 0,
            })
        },
        [onSubmit]
    )

    if (!roster) {
        return <div>Loading...</div>
    }

    return (
        <Form
            onFinish={onFinish}
            layout={'inline'}
            initialValues={{
                ...roster,
                mvpChecked: roster.mvp === 1,
            }}
        >
            <Form.Item name={'count_goals'} label={'G'}>
                <InputNumber placeholder='Goals' min={0} />
            </Form.Item>
            <Form.Item name={'count_goal_passes'} label={'GP'}>
                <InputNumber placeholder='Goal passes' min={0} />
            </Form.Item>
            <Form.Item name={'count_own_goals'} label={'OG'}>
                <InputNumber placeholder='Own goals' min={0} />
            </Form.Item>
            <Form.Item name={'yellow_card'} label={'YC'}>
                <InputNumber placeholder='Yellow cards' min={0} />
            </Form.Item>
            <Form.Item name={'red_card'} label={'RC'}>
                <InputNumber placeholder='Red cards' min={0} />
            </Form.Item>
            <Form.Item name={'mvpChecked'} label={'MVP'} valuePropName='checked'>
                <Switch />
            </Form.Item>
            <Space>
                <Form.Item>
                    <Button htmlType={'submit'} type={'primary'}>
                        Save
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button htmlType={'reset'} type={'default'}>
                        Reset
                    </Button>
                </Form.Item>
            </Space>
        </Form>
    )
})
